/**
 * @generated SignedSource<<02178c31338e72ddfb0971bf9473ac2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type JobRateType = "Contract" | "FTE" | "%future added value";
export type FindRateInput = {
  clientMutationId?: string | null;
  description: string;
  gss?: boolean | null;
  industries: ReadonlyArray<number | null>;
  isTravel?: boolean | null;
  jobLabel: string;
  jobTitle: string;
  jobTitleId: number;
  locationIds?: ReadonlyArray<string | null> | null;
  rateType?: JobRateType | null;
  regionIds?: ReadonlyArray<number | null> | null;
  showLevels?: boolean | null;
  showMarkups?: boolean | null;
  showQuantiles?: boolean | null;
  useLocationModifier?: boolean | null;
  workerTypeId?: number | null;
  workerTypeName?: string | null;
};
export type ModifyLocationsDialogMutation$variables = {
  input: FindRateInput;
};
export type ModifyLocationsDialogMutation$data = {
  readonly ratesearches: {
    readonly searches: {
      readonly ratesearches: ReadonlyArray<{
        readonly jobLabel: string | null;
        readonly jobTitle: string | null;
        readonly results: ReadonlyArray<{
          readonly searchId: number | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};
export type ModifyLocationsDialogMutation = {
  response: ModifyLocationsDialogMutation$data;
  variables: ModifyLocationsDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FindRatePayload",
    "kind": "LinkedField",
    "name": "ratesearches",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RateSavedSearchesNode",
        "kind": "LinkedField",
        "name": "searches",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RateSearchesNode",
            "kind": "LinkedField",
            "name": "ratesearches",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jobLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SavedSearchesList",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "searchId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ModifyLocationsDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ModifyLocationsDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6e429c2bc07fdbb097bcbffa55822b96",
    "id": null,
    "metadata": {},
    "name": "ModifyLocationsDialogMutation",
    "operationKind": "mutation",
    "text": "mutation ModifyLocationsDialogMutation(\n  $input: FindRateInput!\n) {\n  ratesearches(input: $input) {\n    searches {\n      ratesearches {\n        jobTitle\n        jobLabel\n        results {\n          searchId\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0a783e7c7cbc3d60e2394d9f82367a5";

export default node;
